import React, { Component } from "react";
import "./footer.scss";
import logo from "../assets/images/logo.svg";
import instagram from "../assets/images/Footer/instagram.svg";
import ok from "../assets/images/Footer/odnoklassniki.svg";
import twitter from "../assets/images/Footer/twitter.svg";
import youtube from "../assets/images/Footer/youtube.svg";
import vk from "../assets/images/Footer/vkontakte.svg";
import linkedin from "../assets/images/Footer/linkedin.svg";
import facebook from "../assets/images/Footer/facebook.svg";
import telegram from "../assets/images/Footer/telegram.svg";
import btnAppstore from "../assets/images/Footer/btn_appstore_ru.svg";
import btnGoogleplay from "../assets/images/Footer/btn_googleplay_ru.svg";

class Footer extends Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    return (
      <footer className="footer">
        <div className="container">
          <div className="footer_information">
            <div className="footer_address">
              <a href="https://alif.tj/">
                <img src={logo} alt="logo alif" />
              </a>
              <address id="address">
                101 мкр-н, ул. Багаутдинова, 9
                <br />
                Ориентир: ресторан «Канд»
              </address>
              <a
                href="https://alif.tj/main/contacts/service-point"
                id="service_point"
                rel="noreferrer"
              >
                Филиалы и точки обслуживания
              </a>
            </div>
            <div className="footer_phone_main">
              <div className="footer_phone">
                <h1>
                  <a href="tel:900">900</a>
                </h1>
                <p>
                  Для звонков с мобильных
                  <br />в Таджикистане
                </p>
              </div>
              <div className="footer_phone">
                <h1>
                  <a href="tel:+992 48-888-1111">+992 48 888 1111</a>
                </h1>
                <p>
                  Для звонков
                  <br />
                  из любой точки мира
                </p>
              </div>
              <div className="footer_phone">
                <h1>
                  <a href="tel:+992 44-600-1520">+992 44 600 1520</a>
                </h1>
                <p>Телефон доверия НБТ</p>
              </div>
            </div>
            <div className="footer_media">
              <div className="footer_social">
                <h1>Соцмедиа</h1>
                <div className="footer_social_icon">
                  <div>
                    <a
                      href="https://alf.tj/sotsseti_ins"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={instagram} alt="instagram" />
                    </a>

                    <a
                      href="https://alf.tj/sotsseti_ok"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={ok} alt="odnoklassniki" />
                    </a>

                    <a
                      href="https://alf.tj/socceti_tw"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={twitter} alt="twitter" />
                    </a>

                    <a
                      href="https://alf.tj/sotsseti_youtube"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={youtube} alt="youtube" />
                    </a>
                  </div>

                  <div>
                    <a
                      href="https://alf.tj/sotsseti_vk"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={vk} alt="vkontakte" />
                    </a>

                    <a
                      href="https://alf.tj/sotsseti_linkedin"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={linkedin} alt="linkedin" />
                    </a>

                    <a
                      href="https://alf.tj/sotsseti_fb"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={facebook} alt="facebook" />
                    </a>

                    <a
                      href="https://alf.tj/sotsseti_tg"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={telegram} alt="telegram" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="footer_mobile">
                <h1>Мобильное приложение</h1>
                <div className="footer_logo_mobile">
                  <a
                    href="https://goo.gl/5oNT1V"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={btnAppstore} alt="ios" />
                  </a>
                  <a
                    href="https://goo.gl/tNydMC"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={btnGoogleplay} alt="play" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="footer_copyright">
            <p className="footer_company">© 2024 ОАО «Алиф Банк»</p>
            <p className="footer_license">
              Лицензия НБТ №0000114 от 3 января 2020 года
            </p>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
